export default class UserErrorMap {
  constructor(public isError: boolean, public message: string) {}
}
